import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        wordDefinitions: {}
    },
    mutations: {
        add_word_definition(state, { wordId, wordDefinition }) {
            state.wordDefinitions[wordId] = wordDefinition
        }
    },
    actions: {
        fetch_word_definition(context, data) {
            if (context.state.wordDefinitions[data.id]) {
                return
            }

            const url = `${document.location.origin}/${process.env.DICTIONARY_BASE_URL}?id=${data.id}`
            globalFetch(url)
                .then((res) => {
                    if (res.ok) return res.json()
                    throw new Error('Dictionary lookup failed')
                })
                .then((json) => {
                    context.commit('add_word_definition', {
                        wordId: data.id,
                        wordDefinition: json
                    })
                })
                .catch((err) => console.error(err))
        }
    },
    getters: {
        getWordDefinitionById: (state) => (wordId) => {
            if (state.wordDefinitions[wordId]) {
                return state.wordDefinitions[wordId]
            }

            return ''
        }
    }
}
